module.exports = __webpack_public_path__ + "img/right_img1_mobile.a5ff79b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/right_img1_mobile.png
// module id = CP21
// module chunks = 0